<template>
  <div id="messageAdd" ref="messageRef">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>          
        </v-flex>
      </v-layout>
    </v-container>    
    <v-form ref="formAdd">
      <v-container class="-border">
        <v-layout wrap>
          <v-flex xs12 class="button-container pr-3 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="backToListing">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Send</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-select 
              v-model="messageTo"
              @change="changedData" 
              :items="recipientList"
              item-text="name"
              item-value="human[0].id"
              label="To"
              :rules="[rules.toRule]"
              class="required pr-4 pl-4"
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-text-field 
              label="Subject" 
              v-model="conversation.subject" 
              class="required pr-4 pl-4" 
              @input="changedData" 
              :rules="[rules.subjectRule]">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
          <v-combobox class="pr-4 pl-4" :rules="[rules.multipleEmail]" @change="changedData" v-model="conversation.cc" label="CC" hint="emails - hit enter to add new" multiple deletable-chips small-chips></v-combobox>
          </v-flex>
        </v-layout>     
        <v-layout>
          <v-flex>
            <div id="pageEditor">
              <v-container grid-list-xl fluid>
                <v-layout row wrap>
                  <v-flex sm12>
                    <editor :options="editorOption" :content="content" :init="{ height: 300, menubar: false}" :api-key="apikey" v-model="message.content" @input="changedData" :rules="[rules.contentRule]" />
                    <!-- <quill-editor
                      :class="{'height-300': $vuetify.breakpoint.smAndUp}"
                      :content="content"
                      :options="editorOption"
                      @input="changedData"
                      v-model="message.content"
                      :rules="[rules.contentRule]"
                    >
                    </quill-editor> -->
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </v-flex>
        </v-layout>
        <v-layout class="editor-button-container">
          <v-flex xs12 class="button-container pr-3 text-xs-right" v-if="selectedData">
            <div class="d-inline-flex">
              <v-btn class="pf-btn pf-btn-cancel" @click="backToListing">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Send</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session router store config */
/* import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor'; */
import Editor from '@tinymce/tinymce-vue';

import swal from 'sweetalert2';
import { getCollection, create, getOne, conversationListPopulate } from '../../helpers/helpers';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import session from '../../helpers/session';

export default {
  name: 'adminParentMessageAdd',
  components: {
    Editor
  },
  data: () => ({
    recipientList: [],
    agencyAdminList: [],
    entity: 'Message',
    conversationEntity: 'Conversation',
    editor: null,
    config: config,
    apikey: config.tinymceEditorKey,
    content: '',
    selectedData: false,
    editorOption: {
      placeholder: 'Add content here..',
    },
    messageTo: '',
    message: {
      content: '',
      conversation: '',
      sender: ''
    },
    conversation: {
      human: [],
      subject: '',
      cc: []
    },
    rules: {
      subjectRule: (v) => !!v || 'Please enter subject',
      toRule: (v) => !!v || 'Please select recipient',
      contentRule: (v) => !!v || 'Please enter reply',
      multipleEmail: (v) => v === undefined || v.length === 0 || /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/.test(v) || 'Please enter valid email address',
    },
  }),  
  computed: {
    ...mapGetters(['Agency', 'Account', 'Message', 'Conversation']),
    Conversation: {
      get () {
        return store.state.Conversation;
      },
      set (value) {
        store.commit('setConversation', value);
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  async created () {
    window.getApp.$emit('pageSubHeader', 'Add');
    await this.getAgencyAdmins();
    this.recipientList = [...[this.Account], ...this.agencyAdminList];
    this.messageTo = this.recipientList[0].human[0].id;
  },
  mounted () {
    this.$refs.messageRef.scrollIntoView({ behavior: 'smooth' });
  },
  methods: {
    async updateConversationList () {
      let sort = { 'updatedAt': -1 };
      let sessionUser = session.getSession();
      let where = {};
      where = {
        $and: [
          {
            $or: [
              {
                human: sessionUser.user.human.id
              }
            ]
          },
          {
            $or: [
              {
                archive: { $exists: false }
              },
              {
                archive: {
                  $ne: sessionUser.user.human.id
                }
              }
            ]
          },
          {
            $or: [
              {
                removed: { $exists: false }
              },
              {
                removed: {
                  $ne: sessionUser.user.human.id
                }
              }
            ]
          }
        ]
      };
      if (sessionUser.user.human.group && sessionUser.user.human.group.length) {
        where.$and[0].$or.push({
          groups: {
            $in: sessionUser.user.human.group && sessionUser.user.human.group.length ? sessionUser.user.human.group.map(group => group.group) : []
          }
        });
      }
      let { error, data } = await getCollection(this.conversationEntity, true, 0, await conversationListPopulate(sessionUser.user.human.id), where, null, null, sort);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          this.Conversation = data;
        }
      }
    },
    async getAgencyAdmins () {
      let where = { is_admin: true };
      let attributes = 'name,createdAt,_id';
      let populate = [{ path: 'human', select: '_id name user' }];
      let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          this.agencyAdminList = data.filter(admin => admin.id !== session.getSession().adminUser.human.agency);
        }
      }
    },
    async save () {
      if (this.$refs.formAdd.validate()) {
        if (!this.message.content.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
          swal.fire({
            type: 'warning',
            title: 'Content is required.',
            text: 'Please add message content before saving!',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          });
          return;
        }
        this.selectedData = false;
        if (this.conversation.cc && !this.conversation.cc.length) {
          delete this.conversation.cc;
        }
        this.conversation.human.push(this.messageTo);
        this.conversation.human.push(session.getSession().adminUser.human.id);
        let { error, data, status } = await create(this.conversationEntity, this.conversation);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.loading = false;
          this.message.conversation = data.id;
          this.message.sender = session.getSession().adminUser.human.id;
          this.saveMessage();
        }
      }
    },
    async saveMessage () {
      let { error, data, status } = await create(this.entity, this.message);
      if (error) {
        this.selectedData = true;
        console.log('error', error);
      } else {
        swal.fire({
          type: 'success',
          title: 'Message sent successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            if (this.$route.query.preUrl === 'Messages') {
              this.$router.push({ path: `/messages` });
            } else {
              this.$router.push({ path: session.role() === 'parent' ? `/dashboard` : `/agency/dashboard` });
            }
          }
        });
        this.updateConversationList();
      }
    },
    changedData () {
      this.selectedData = true;
    },
    hideButtons () {
      this.selectedData = false;
    },
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      if (this.$route.query.preUrl === 'Messages') {
        this.$router.push({ path: `/messages` });
      } else {
        this.$router.push({ path: session.role() === 'parent' ? `/dashboard` : `/agency/dashboard` });
      }
    }      
  }
};
</script>

<style lang="css" scoped>
  .editor-button-container{
    padding-top: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Messages/admin_parent.vue